import { useCallback } from 'react';

import axios, { endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export function useReportContext() {
  const getContext = useCallback(async (reportUri) => {
    const { data } = await axios.get(endpoints.knowledge.reportContext(reportUri));
    return data?.context || '';
  }, []);

  const saveContext = useCallback(async (reportUri, context) => {
    const { data } = await axios.put(endpoints.knowledge.reportContexts, {
      report_uri: reportUri,
      context,
    });
    return data;
  }, []);

  return { getContext, saveContext };
}
